"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7046],{

/***/ 23483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseIconBlack = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.46584 8.00012L15.6959 1.76972C16.1014 1.36446 16.1014 0.709208 15.6959 0.303946C15.2907 -0.101315 14.6354 -0.101315 14.2302 0.303946L7.99991 6.53434L1.76983 0.303946C1.36438 -0.101315 0.709335 -0.101315 0.304082 0.303946C-0.101361 0.709208 -0.101361 1.36446 0.304082 1.76972L6.53416 8.00012L0.304082 14.2305C-0.101361 14.6358 -0.101361 15.291 0.304082 15.6963C0.506044 15.8984 0.771594 16 1.03695 16C1.30231 16 1.56767 15.8984 1.76983 15.6963L7.99991 9.46589L14.2302 15.6963C14.4323 15.8984 14.6977 16 14.963 16C15.2284 16 15.4938 15.8984 15.6959 15.6963C16.1014 15.291 16.1014 14.6358 15.6959 14.2305L9.46584 8.00012Z",
            fill: "black"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIconBlack);


/***/ }),

/***/ 93757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var OfferIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 15 : _height, _width = param.width, width = _width === void 0 ? 15 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.236 8.62713L9.244 0.635127C9.07948 0.471113 8.88419 0.341193 8.66934 0.252817C8.4545 0.164442 8.22431 0.11935 7.992 0.120127H1.776C1.30538 0.121446 0.854417 0.308984 0.521638 0.641763C0.188859 0.974542 0.00132197 1.42551 2.59218e-06 1.89613V8.11213C-0.000398322 8.34653 0.0457096 8.57867 0.135656 8.79513C0.225602 9.01158 0.357599 9.20804 0.524002 9.37313L8.516 17.3651C8.68053 17.5291 8.87582 17.6591 9.09066 17.7474C9.30551 17.8358 9.53569 17.8809 9.768 17.8801C10.0012 17.8813 10.2322 17.8356 10.4473 17.7456C10.6624 17.6555 10.8572 17.5231 11.02 17.3561L17.236 11.1401C17.403 10.9773 17.5354 10.7826 17.6254 10.5675C17.7155 10.3524 17.7612 10.1213 17.76 9.88813C17.7584 9.41515 17.5701 8.96195 17.236 8.62713ZM9.768 16.1131L1.776 8.11313V1.89613H7.992V1.88713L15.984 9.87913L9.768 16.1131Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.2041 5.32422C4.75639 5.32422 5.2041 4.8765 5.2041 4.32422C5.2041 3.77193 4.75639 3.32422 4.2041 3.32422C3.65182 3.32422 3.2041 3.77193 3.2041 4.32422C3.2041 4.8765 3.65182 5.32422 4.2041 5.32422Z",
                fill: "currentColor"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OfferIcon);


/***/ }),

/***/ 75513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16628);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13508);





var Transition = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Transition(props, ref) {
    if (src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            in: true,
            ref: ref
        }, props));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        direction: "up",
        ref: ref
    }, props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Transition);


/***/ }),

/***/ 75868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50594);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64666);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13508);
/* harmony import */ var _Transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75513);






/**
 * Modal with a sticky header, having border at bottom.
 * Add the additional parameters here if required.
 */ var BasicModal = function(param) {
    var show = param.show, onClose = param.onClose, children = param.children, _heading = param.heading, heading = _heading === void 0 ? "" : _heading, _showCloseIcon = param.showCloseIcon, showCloseIcon = _showCloseIcon === void 0 ? true : _showCloseIcon, _customCloseIcon = param.customCloseIcon, customCloseIcon = _customCloseIcon === void 0 ? null : _customCloseIcon, _closeIconClass = param.closeIconClass, closeIconClass = _closeIconClass === void 0 ? "" : _closeIconClass, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _headingClasses = param.headingClasses, headingClasses = _headingClasses === void 0 ? "" : _headingClasses;
    var defaultContainerClasses = "tw-rounded-[8px_8px_0px_0px] md:tw-rounded-[8px]";
    var defaultHeadingClass = "tw-text-[18px]/[20px] tw-font-semibold";
    var defaultCloseIconClass = "tw-absolute tw-right-[16px] tw-top-[16px] tw-cursor-pointer";
    var getCloseIconIfAny = function() {
        return showCloseIcon ? customCloseIcon ? customCloseIcon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            fontSize: "small",
            className: "".concat(defaultCloseIconClass, " ").concat(closeIconClass),
            onClick: onClose
        }) : null;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "",
        open: show,
        onClose: onClose,
        classes: {
            paper: "".concat(!src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn ? "tw-absolute tw-bottom-0" : "", " tw-w-full md:tw-min-w-[672px] tw-m-0 ").concat(defaultContainerClasses, " ").concat(customClasses),
            root: ""
        },
        TransitionComponent: _Transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-relative tw-flex tw-h-full tw-flex-col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-sticky tw-top-0 tw-z-10 tw-flex tw-justify-between tw-border-b tw-border-solid tw-border-gray1 tw-bg-white tw-px-[24px] tw-py-[16px] ".concat(defaultHeadingClass, " ").concat(headingClasses),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: heading || ""
                        }),
                        getCloseIconIfAny()
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-flex-1 tw-overflow-scroll",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BasicModal);


/***/ }),

/***/ 45305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92134);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13508);




var BasicPromoStrip = function(param) {
    var _promoId = param.promoId, promoId = _promoId === void 0 ? null : _promoId, _primaryText = param.primaryText, primaryText = _primaryText === void 0 ? "" : _primaryText, _secondaryText = param.secondaryText, secondaryText = _secondaryText === void 0 ? "" : _secondaryText, _ctaTextOrIcon = param.ctaTextOrIcon, ctaTextOrIcon = _ctaTextOrIcon === void 0 ? null : _ctaTextOrIcon, _onCtaClick = param.onCtaClick, onCtaClick = _onCtaClick === void 0 ? null : _onCtaClick, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#ffffff" : _bgColor, _showHoverEffect = param.showHoverEffect, showHoverEffect = _showHoverEffect === void 0 ? true : _showHoverEffect, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _primaryTextClasses = param.primaryTextClasses, primaryTextClasses = _primaryTextClasses === void 0 ? "" : _primaryTextClasses, _secondaryTextClasses = param.secondaryTextClasses, secondaryTextClasses = _secondaryTextClasses === void 0 ? "" : _secondaryTextClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripContainer */ .P6, {
        showHoverEffect: showHoverEffect,
        bgColor: bgColor,
        customClasses: customClasses,
        onClick: function() {
            !src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_3__/* .IS_DESKTOP */ .yn && onCtaClick(promoId);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripIconInfoWrapper */ .To, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripOfferIcon */ .YT, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "tw-m-0 ".concat(primaryTextClasses),
                                children: primaryText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "tw-m-0 ".concat(secondaryTextClasses),
                                children: [
                                    "Use code - ",
                                    secondaryText
                                ]
                            })
                        ]
                    })
                ]
            }),
            " ",
            ctaTextOrIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripCTA */ .iQ, {
                onClick: function() {
                    return onCtaClick(promoId);
                },
                ctaTextOrIcon: ctaTextOrIcon
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BasicPromoStrip);


/***/ }),

/***/ 92134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OK": function() { return /* binding */ Tab; },
/* harmony export */   "P6": function() { return /* binding */ StripContainer; },
/* harmony export */   "To": function() { return /* binding */ StripIconInfoWrapper; },
/* harmony export */   "YT": function() { return /* binding */ StripOfferIcon; },
/* harmony export */   "iQ": function() { return /* binding */ StripCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70758);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13508);
/* harmony import */ var src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93757);




var StripOfferIcon = function(param) {
    var _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? null : _iconSize, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var offerIconSize = iconSize || (src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_DESKTOP */ .yn ? 18 : 14);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: customClasses,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_assets_svgExports_OfferIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            height: offerIconSize,
            width: offerIconSize
        })
    });
};
var Tab = function(param) {
    var text = param.text, isActive = param.isActive, onClick = param.onClick, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses;
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__/* .getThemeColor */ .p)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "removeGlobalOverride tw-m-0 tw-cursor-pointer tw-border-x-0 tw-border-b-[3px] tw-border-t-0 tw-border-solid tw-bg-transparent tw-px-[12px] tw-pb-[9px] tw-text-[13px]/[20px] ".concat(isActive ? "tw-font-semibold" : "tw-font-medium", " tw-transition-colors tw-duration-500 md:tw-pb-[13px] md:tw-text-[14px]/[20px] ").concat(customClasses),
        onClick: onClick,
        style: {
            borderColor: isActive ? themeColor : "#ffffff",
            color: isActive ? themeColor : "#000000"
        },
        children: text
    });
};
var StripIconInfoWrapper = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[8px] ".concat(props.customClasses || ""),
        children: props.children
    });
};
var StripContainer = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-flex-col tw-items-start tw-gap-[8px] tw-border-b tw-border-dashed tw-border-[#EAEAEA]  ".concat(props.showHoverEffect ? "hover:tw-bg-[#F5F5F5]" : "", " md:tw-flex-row md:tw-justify-between md:tw-border-none ").concat(props.customClasses || ""),
        style: {
            backgroundColor: props.bgColor
        },
        onClick: props.onClick,
        children: props.children
    });
};
var StripCTA = function(param) {
    var _ctaTextOrIcon = param.ctaTextOrIcon, ctaTextOrIcon = _ctaTextOrIcon === void 0 ? "Details" : _ctaTextOrIcon, onClick = param.onClick, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled;
    var themeColor = (0,src_utils_getThemeColor__WEBPACK_IMPORTED_MODULE_1__/* .getThemeColor */ .p)();
    var handleCTAClick = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        onClick();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "tw-ml-[20px] tw-w-fit ".concat(isDisabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer", " tw-border-none tw-bg-transparent tw-p-0 tw-text-[14px]/[20px] tw-font-semibold md:tw-ml-0 md:tw-text-[16px]/[20px] ").concat(isDisabled ? "tw-opacity-40" : "", " ").concat(customClasses),
        style: {
            color: themeColor
        },
        onClick: handleCTAClick,
        disabled: isDisabled,
        children: ctaTextOrIcon
    });
};


/***/ }),

/***/ 67046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var actions_storeInfo = __webpack_require__(17321);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(44779);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@dotpe/kui/styles/theme/generate.js
var generate = __webpack_require__(72327);
// EXTERNAL MODULE: ./node_modules/@dotpe/kui/styles/theme/theme.js
var theme = __webpack_require__(52301);
;// CONCATENATED MODULE: ./src/components/Layout/theme.tsx




var ThemeCss = function() {
    var cssTheme = (0,generate.getCssFromThemeObject)(theme.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,jsx_runtime.jsx)((style_default()), {
            id: cssTheme.__hash,
            children: cssTheme
        })
    });
};

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/utils/constants/images.js
var constants_images = __webpack_require__(84320);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/constants/globalConfigs.ts
var globalConfigs = __webpack_require__(37392);
// EXTERNAL MODULE: ./src/utils/checkIfObjectExists.ts
var checkIfObjectExists = __webpack_require__(31891);
;// CONCATENATED MODULE: ./src/components/Layout/utils.ts



var getGLobalStyleEssentials = function(globalConfig) {
    var ref;
    var globalStyles = globalConfig && !(0,lodash.isEmpty)(globalConfig) ? globalConfig : {
        fonts: globalConfigs/* GLOBAL_STYLE.fonts */.$.fonts
    };
    var fontStyles = globalStyles === null || globalStyles === void 0 ? void 0 : globalStyles.fonts;
    var fontURls = fontStyles ? (ref = Object.values(fontStyles)) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, item) {
        if ((0,checkIfObjectExists/* checkIfObjectExists */.L)(item)) {
            if (!acc.find(function(oldList) {
                return oldList.fontCdn === item.fontCdn;
            })) acc.push({
                fontFamily: item.fontFamily,
                fontCdn: item.fontCdn
            });
        }
        return acc;
    }, []) : [];
    if (!fontURls.length) {
        fontURls.push({
            fontFamily: "Inter",
            fontCdn: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
        });
    }
    return {
        fontURls: fontURls,
        fontStyles: fontStyles
    };
};
var getSocialMediaLink = function(storeMediaData) {
    var mediaCount = storeMediaData === null || storeMediaData === void 0 ? void 0 : storeMediaData.media_count;
    if (!mediaCount) {
        return [];
    }
    var mediaData = storeMediaData === null || storeMediaData === void 0 ? void 0 : storeMediaData.media_detail;
    return mediaData.map(function(item) {
        return item.profile_url;
    }).filter(function(url) {
        return url !== "";
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/RichSnippetStoreDetails.tsx







var RichSnippetStoreDetails = function(props) {
    var ref, ref1;
    var ref2 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1;
        return {
            storeFromSelector: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store,
            storePolicy: ((ref1 = state.storePolicyReducer) === null || ref1 === void 0 ? void 0 : ref1.data[0]) || null
        };
    }), storeFromSelector = ref2.storeFromSelector, storePolicy = ref2.storePolicy;
    var store = props.store || storeFromSelector;
    var storeData = {
        logo_image: (store === null || store === void 0 ? void 0 : store.logo_image) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a,
        store_url: store === null || store === void 0 ? void 0 : store.store_url,
        description: (store === null || store === void 0 ? void 0 : store.description) || "",
        store_name: store === null || store === void 0 ? void 0 : store.store_name,
        display_number: store === null || store === void 0 ? void 0 : store.display_phone
    };
    var storeAddress = store === null || store === void 0 ? void 0 : store.address;
    var ref3 = (0,useStoreContactDetails/* default */.Z)(true), storeEmail = ref3.storeEmail, storePhone = ref3.storePhone;
    var socialMediaLink = getSocialMediaLink(store === null || store === void 0 ? void 0 : store.social_media_profile_details);
    var isReturnPolicy = storePolicy === null || storePolicy === void 0 ? void 0 : (ref = storePolicy.additional_config_return_refund_policy) === null || ref === void 0 ? void 0 : ref.is_accepting_returns;
    var refundDay = storePolicy === null || storePolicy === void 0 ? void 0 : (ref1 = storePolicy.additional_config_return_refund_policy) === null || ref1 === void 0 ? void 0 : ref1.day_count;
    var hasValidStoreData = (storeData === null || storeData === void 0 ? void 0 : storeData.logo_image) && (storeData === null || storeData === void 0 ? void 0 : storeData.store_url);
    var storeSchema = (0,_object_spread/* default */.Z)({
        "@context": "https://www.schema.org",
        "@type": "OnlineStore",
        name: storeData === null || storeData === void 0 ? void 0 : storeData.store_name,
        description: storeData === null || storeData === void 0 ? void 0 : storeData.description,
        url: storeData === null || storeData === void 0 ? void 0 : storeData.store_url,
        logo: storeData === null || storeData === void 0 ? void 0 : storeData.logo_image,
        contactPoint: (0,_object_spread/* default */.Z)({
            "@type": "ContactPoint",
            contactType: "Customer Service"
        }, storePhone && {
            telephone: storePhone
        }, storeEmail && {
            email: storeEmail
        })
    }, socialMediaLink.length && {
        sameAs: socialMediaLink
    }, isReturnPolicy ? {
        hasMerchantReturnPolicy: {
            "@type": "MerchantReturnPolicy",
            returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow ",
            merchantReturnDays: refundDay,
            applicableCountry: "IN",
            returnPolicyCountry: "IN"
        }
    } : {
        hasMerchantReturnPolicy: {
            "@type": "MerchantReturnPolicy",
            returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted"
        }
    }, (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.address_1) && {
        address: {
            "@type": "PostalAddress",
            streetAddress: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.address_1) || "",
            addressLocality: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.city) || "",
            addressCountry: "IN",
            addressRegion: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.state) || "",
            postalCode: (storeAddress === null || storeAddress === void 0 ? void 0 : storeAddress.pincode) || ""
        }
    });
    return hasValidStoreData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(storeSchema)
        }
    }) : null;
};

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/checkIfThemeEditorOrPreview.js
var checkIfThemeEditorOrPreview = __webpack_require__(35069);
// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(75868);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/BasicPromoStrip/index.tsx
var BasicPromoStrip = __webpack_require__(45305);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(68615);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoModal/Common.tsx





var RedirectionLink = function(param) {
    var name = param.name, route = param.route, onClose = param.onClose;
    var domain = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store.domain;
    });
    var onLinkClick = function() {
        router_default().push((0,routes.getRoute)(route, domain));
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "tw-flex tw-cursor-pointer tw-border tw-border-solid tw-border-[#DBDBDB] tw-bg-transparent tw-px-[12px] tw-py-[4px] tw-text-[13px]/[20px] tw-text-black tw-no-underline hover:tw-bg-[#F7F7F7]",
        onClick: onLinkClick,
        children: name
    });
};
var RedirectionLinks = function(param) {
    var promoData = param.promoData, onClose = param.onClose;
    var requiredLinksData = (promoData === null || promoData === void 0 ? void 0 : promoData.required_entity_chips) || [];
    var rewardListData = (promoData === null || promoData === void 0 ? void 0 : promoData.reward_entity_chips) || [];
    var ref = (0,react.useState)(false), showMoreRequired = ref[0], setShowMoreRequired = ref[1];
    var ref1 = (0,react.useState)(false), showMoreReward = ref1[0], setShowMoreReward = ref1[1];
    var renderRequiredLinks = function(requiredLinks) {
        var totalRequiredLinks = requiredLinks === null || requiredLinks === void 0 ? void 0 : requiredLinks.length;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                requiredLinks.slice(0, showMoreRequired ? totalRequiredLinks : 6).map(function(linkData, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(RedirectionLink, {
                        name: linkData === null || linkData === void 0 ? void 0 : linkData.text,
                        route: linkData === null || linkData === void 0 ? void 0 : linkData.url,
                        onClose: onClose
                    }, index);
                }),
                totalRequiredLinks > 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-flex tw-cursor-pointer tw-items-center tw-text-[13px]/[20px] tw-font-semibold",
                    onClick: function() {
                        return setShowMoreRequired(!showMoreRequired);
                    },
                    children: showMoreRequired ? "Less" : "More"
                })
            ]
        });
    };
    var renderRewardChips = function(rewardChips) {
        var totalRewardChips = rewardChips === null || rewardChips === void 0 ? void 0 : rewardChips.length;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                rewardChips.slice(0, showMoreReward ? totalRewardChips : 6).map(function(rewardData) {
                    return (rewardData === null || rewardData === void 0 ? void 0 : rewardData.text) || "";
                }).join(", "),
                totalRewardChips > 6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "tw-flex tw-cursor-pointer tw-items-center tw-text-[13px]/[20px] tw-font-semibold",
                    onClick: function() {
                        return setShowMoreReward(!showMoreReward);
                    },
                    children: [
                        "...",
                        showMoreReward ? "Less" : "More"
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!(requiredLinksData === null || requiredLinksData === void 0 ? void 0 : requiredLinksData.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[8px] md:tw-gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[14px]/[20px] tw-font-semibold",
                        children: (promoData === null || promoData === void 0 ? void 0 : promoData.requirement_header_text) || ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-flex-wrap tw-gap-[8px]",
                        children: renderRequiredLinks(requiredLinksData)
                    })
                ]
            }),
            !!(rewardListData === null || rewardListData === void 0 ? void 0 : rewardListData.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-mb-[8px] tw-flex tw-flex-col tw-gap-[8px] md:tw-gap-[12px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[14px]/[20px] tw-font-semibold",
                        children: (promoData === null || promoData === void 0 ? void 0 : promoData.reward_header_text) || ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-flex-wrap tw-text-[13px]/[20px]",
                        children: renderRewardChips(rewardListData)
                    })
                ]
            })
        ]
    });
};
var PromoEligibilies = function(param) {
    var eligibiltyTexts = param.eligibiltyTexts;
    return !!(eligibiltyTexts === null || eligibiltyTexts === void 0 ? void 0 : eligibiltyTexts.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[8px] md:tw-gap-[12px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-m-0 tw-text-[14px]/[20px] tw-font-semibold",
                children: "Offer Eligibility"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "tw-ml-[12px] tw-list-outside",
                children: eligibiltyTexts.map(function(text, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "tw-text-[13px]/[22px] md:tw-text-[14px]/[22px]",
                        children: text
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoModal/index.tsx







var PromoModal = function() {
    var getPromoData = function getPromoData() {
        var params = {
            storeId: storeId,
            promoId: promoId
        };
        dispatch((0,promo/* getPromoDataById */.lT)(params, function(data) {
            setPromoData(data);
        }));
    };
    var onClose = function onClose() {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: false,
            promoId: null
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            promoModalState: state.commonReducer.promoDetailModalState || {},
            storeId: state.storeReducer.store.store_id
        };
    }), _promoModalState = ref.promoModalState, _show = _promoModalState.show, show = _show === void 0 ? false : _show, _promoId = _promoModalState.promoId, promoId = _promoId === void 0 ? null : _promoId, storeId = ref.storeId;
    var ref1 = (0,react.useState)(null), promoData = ref1[0], setPromoData = ref1[1];
    (0,react.useEffect)(function() {
        if (show) {
            getPromoData();
        }
    }, [
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
        show: show,
        onClose: onClose,
        heading: "Offer Details",
        customClasses: "tw-max-h-[466px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[24px] tw-px-[20px] tw-py-[16px] md:tw-px-[32px] md:tw-py-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicPromoStrip/* default */.Z, {
                    primaryText: (promoData === null || promoData === void 0 ? void 0 : promoData.description) || "",
                    secondaryText: (promoData === null || promoData === void 0 ? void 0 : promoData.code) || "",
                    bgColor: "#F0F0F0",
                    showHoverEffect: false,
                    customClasses: "tw-rounded-[8px] md:tw-rounded-[0px] tw-px-[16px] md:tw-px-[24px] tw-py-[16px]",
                    primaryTextClasses: "tw-text-[14px]/[18px] md:tw-text-[16px]/[20px] tw-font-semibold",
                    secondaryTextClasses: "tw-text-[13px]/[20px] tw-font-normal md:tw-text-[15px]/[20px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RedirectionLinks, {
                    promoData: promoData,
                    onClose: onClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoEligibilies, {
                    eligibiltyTexts: (promoData === null || promoData === void 0 ? void 0 : promoData.offer_eligiblities) || []
                })
            ]
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoModal = (PromoModal);

// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconBlack.js
var CloseIconBlack = __webpack_require__(23483);
// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(93757);
// EXTERNAL MODULE: ./src/components/BasicModal/Transition.tsx
var Transition = __webpack_require__(75513);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoRemovalAlertModal/index.tsx










var PromoRemovalAlertModal = function() {
    var closeModal = function closeModal() {
        dispatch((0,promo/* togglePromoRemovalAlertModal */._p)({
            show: false,
            cartDataAfterOfferRemoval: null
        }));
    };
    var onCancel = function onCancel() {
        dispatch((0,cart/* setCart */.RV)(latestSyncedCart));
        closeModal();
    };
    var onProceed = function onProceed() {
        dispatch((0,cart/* saveCart */.FP)(cartDataAfterOfferRemoval));
        closeModal();
    };
    var ref, ref1, ref2;
    var dispatch = (0,es/* useDispatch */.I0)();
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            promoRemovalAlertModalState: ((ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.promoRemovalAlertModalState) || {},
            latestSyncedCart: (ref1 = state.commonReducer) === null || ref1 === void 0 ? void 0 : ref1.latestSyncedCart
        };
    }), _promoRemovalAlertModalState = ref3.promoRemovalAlertModalState, _show = _promoRemovalAlertModalState.show, show = _show === void 0 ? false : _show, _cartDataAfterOfferRemoval = _promoRemovalAlertModalState.cartDataAfterOfferRemoval, cartDataAfterOfferRemoval = _cartDataAfterOfferRemoval === void 0 ? null : _cartDataAfterOfferRemoval, latestSyncedCart = ref3.latestSyncedCart;
    var earlierAppliedPromoCode = (ref2 = (latestSyncedCart === null || latestSyncedCart === void 0 ? void 0 : (ref = latestSyncedCart.payment_offer) === null || ref === void 0 ? void 0 : ref.promo_code) || (latestSyncedCart === null || latestSyncedCart === void 0 ? void 0 : (ref1 = latestSyncedCart.store_offer) === null || ref1 === void 0 ? void 0 : ref1.promo_code)) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase();
    (0,react.useEffect)(function() {
        if (!earlierAppliedPromoCode) {
            closeModal();
        }
    }, [
        earlierAppliedPromoCode
    ]);
    var secondaryStyle = {
        color: themeColor,
        borderColor: themeColor
    };
    var primaryStyle = {
        backgroundColor: themeColor
    };
    return !!earlierAppliedPromoCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: show,
        classes: {
            paper: "tw-m-0 ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-relative tw-rounded-[8px]" : "tw-absolute tw-left-0 tw-right-0 tw-bottom-0 tw-rounded-[8px_8px_0px_0px]", " tw-px-[24px] tw-py-[32px] md:tw-px-[30px] tw-rounded-[8px] tw-w-full md:tw-w-[560px]")
        },
        onClose: onCancel,
        TransitionComponent: Transition/* default */.Z,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: " tw-absolute tw-right-[22px] tw-top-[22px] tw-cursor-pointer ",
                    onClick: onCancel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconBlack/* default */.Z, {
                        size: 13
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-[32px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[24px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "tw-m-0 tw-text-[20px]/[24px] tw-font-semibold",
                                    children: "Remove Item and discount?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-[12px]/[20px] tw-text-[#111C36] md:tw-text-[15px]/[24px]",
                                    children: "There is a discount coupon applied on this product. Are you sure you want to remove this product and the discount with it?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "tw-flex tw-items-center tw-gap-[6px] tw-text-[14px]/[17px] tw-font-semibold",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {
                                            height: 14,
                                            width: 14
                                        }),
                                        earlierAppliedPromoCode
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col-reverse tw-justify-end tw-gap-[12px] md:tw-flex-row md:tw-gap-[16px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "tw-cursor-pointer tw-rounded-[8px] tw-border-none tw-py-[15px] tw-text-[14px]/[17px] tw-font-semibold tw-text-white md:tw-w-[125px] md:tw-border md:tw-border-solid md:tw-bg-transparent md:tw-py-[12px] md:tw-text-[20px]/[24px]",
                                    style: checkClientDeviceType/* IS_DESKTOP */.yn ? secondaryStyle : primaryStyle,
                                    onClick: onCancel,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "tw-cursor-pointer tw-rounded-[8px] tw-border tw-border-solid tw-bg-transparent tw-py-[15px] tw-text-[14px]/[17px] tw-font-semibold tw-text-white md:tw-w-[125px] md:tw-border-none md:tw-py-[12px] md:tw-text-[20px]/[24px]",
                                    style: checkClientDeviceType/* IS_DESKTOP */.yn ? primaryStyle : secondaryStyle,
                                    onClick: onProceed,
                                    children: checkClientDeviceType/* IS_DESKTOP */.yn ? "Yes" : "Remove Item"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoRemovalAlertModal = (PromoRemovalAlertModal);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/Layout/styles.ts

var GlobalStyleWrapper = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60;
    return "\n    body {\n    font-family: ".concat(((ref = props.fontStyles) === null || ref === void 0 ? void 0 : ref.isEnabled) ? (ref1 = props.fontStyles) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.body) === null || ref2 === void 0 ? void 0 : ref2.fontFamily : "Inter", ";\n    letter-spacing: ").concat(((ref3 = props.fontStyles) === null || ref3 === void 0 ? void 0 : ref3.isEnabled) ? (ref4 = props.fontStyles) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.body) === null || ref5 === void 0 ? void 0 : ref5.letterSpacing : "unset", ";\n\n    h1,h2,h3,h4,h5,h6{\n      &:not(.removeGlobalOverride){\n        font-family: ").concat(((ref6 = props.fontStyles) === null || ref6 === void 0 ? void 0 : ref6.isEnabled) ? (ref7 = props.fontStyles) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.heading) === null || ref8 === void 0 ? void 0 : ref8.fontFamily : "Inter", ";\n        letter-spacing: ").concat(((ref9 = props.fontStyles) === null || ref9 === void 0 ? void 0 : ref9.isEnabled) ? (ref10 = props.fontStyles) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.body) === null || ref11 === void 0 ? void 0 : ref11.letterSpacing : "unset", ";\n        }\n    }\n\n    p {\n      font-family: ").concat(((ref12 = props.fontStyles) === null || ref12 === void 0 ? void 0 : ref12.isEnabled) ? (ref13 = props.fontStyles) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.body) === null || ref14 === void 0 ? void 0 : ref14.fontFamily : "Inter", ";\n      letter-spacing: ").concat(((ref15 = props.fontStyles) === null || ref15 === void 0 ? void 0 : ref15.isEnabled) ? (ref16 = props.fontStyles) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.body) === null || ref17 === void 0 ? void 0 : ref17.letterSpacing : "unset", ";\n    }\n\n    ").concat(props.fontStyles.isEnabled ? "button {\n              &:not(.removeGlobalOverride){\n                  font-family: ".concat((ref19 = props.fontStyles) === null || ref19 === void 0 ? void 0 : (ref20 = ref19[(ref18 = props.fontStyles) === null || ref18 === void 0 ? void 0 : ref18.buttonInherit]) === null || ref20 === void 0 ? void 0 : ref20.fontFamily, ";\n                  letter-spacing: ").concat((ref21 = props.fontStyles) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.body) === null || ref22 === void 0 ? void 0 : ref22.letterSpacing, ";\n            }\n        }\n      ") : "", "\n\n    ").concat(props.buttons.isEnabled ? "button {\n              &:not(.removeGlobalOverride){\n              border-radius: ".concat((ref23 = props.buttons) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.style) === null || ref24 === void 0 ? void 0 : ref24.borderRadius, ";\n            }\n          }") : "", ";\n\n    ").concat(((ref25 = props.imageCards) === null || ref25 === void 0 ? void 0 : ref25.isEnabled) ? "img, video{\n        &:not(.removeGlobalOverride){\n          border-start-start-radius: ".concat(((ref26 = props.imageCards) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.style) === null || ref27 === void 0 ? void 0 : ref27.borderRadius) || "0px", ";\n          border-start-end-radius: ").concat(((ref28 = props.imageCards) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.style) === null || ref29 === void 0 ? void 0 : ref29.borderRadius) || "0px", ";\n          border-end-start-radius: ").concat(((ref30 = props.imageCards) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.style) === null || ref31 === void 0 ? void 0 : ref31.borderRadius) || "0px", ";\n          border-end-end-radius: ").concat(((ref32 = props.imageCards) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.style) === null || ref33 === void 0 ? void 0 : ref33.borderRadius) || "0px", ";\n        }\n\n        .addTopLeftGlobalRadius{\n          border-start-start-radius: ").concat(((ref34 = props.imageCards) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.style) === null || ref35 === void 0 ? void 0 : ref35.borderRadius) || "0px", ";\n          border-start-end-radius: unset;\n          border-end-start-radius: unset;\n          border-end-end-radius: unset;\n        }\n\n         .addTopRightGlobalRadius{\n          border-start-start-radius:unset;\n          border-start-end-radius:  ").concat(((ref36 = props.imageCards) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.style) === null || ref37 === void 0 ? void 0 : ref37.borderRadius) || "0px", ";\n          border-end-start-radius: unset;\n          border-end-end-radius: unset;\n        }\n\n         .addBottomLeftGlobalRadius{\n          border-start-start-radius: unset;\n          border-start-end-radius: unset;\n          border-end-start-radius: ").concat(((ref38 = props.imageCards) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.style) === null || ref39 === void 0 ? void 0 : ref39.borderRadius) || "0px", ";\n          border-end-end-radius: unset;\n        }\n\n         .addBottomRightGlobalRadius{\n          border-start-start-radius: unset;\n          border-start-end-radius: unset;\n          border-end-start-radius: unset;\n          border-end-end-radius: ").concat(((ref40 = props.imageCards) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.style) === null || ref41 === void 0 ? void 0 : ref41.borderRadius) || "0px", ";\n        }\n    }\n    .imgWrapperGlobalStyleMin{\n        :not(.removeGlobalOverride){\n        border-start-start-radius: 20%;\n        border-start-end-radius: 20%;\n        border-end-start-radius: 20%;\n        border-end-end-radius: 20%;\n      }\n    }\n\n    .imgWrapperGlobalStyle{\n        :not(.removeGlobalOverride){\n        border-start-start-radius: ").concat(((ref42 = props.imageCards) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.style) === null || ref43 === void 0 ? void 0 : ref43.borderRadius) || "0px", ";\n        border-start-end-radius: ").concat(((ref44 = props.imageCards) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.style) === null || ref45 === void 0 ? void 0 : ref45.borderRadius) || "0px", ";\n        border-end-start-radius: ").concat(((ref46 = props.imageCards) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.style) === null || ref47 === void 0 ? void 0 : ref47.borderRadius) || "0px", ";\n        border-end-end-radius: ").concat(((ref48 = props.imageCards) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.style) === null || ref49 === void 0 ? void 0 : ref49.borderRadius) || "0px", ";\n        }\n          .addTopLeftGlobalRadius{\n          border-start-start-radius: ").concat(((ref50 = props.imageCards) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.style) === null || ref51 === void 0 ? void 0 : ref51.borderRadius) || "0px", ";\n          border-start-end-radius: unset;\n          border-end-start-radius: unset;\n          border-end-end-radius: unset;\n        }\n\n         .addTopRightGlobalRadius{\n          border-start-start-radius:unset;\n          border-start-end-radius:  ").concat(((ref52 = props.imageCards) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.style) === null || ref53 === void 0 ? void 0 : ref53.borderRadius) || "0px", ";\n          border-end-start-radius: unset;\n          border-end-end-radius: unset;\n        }\n\n         .addBottomLeftGlobalRadius{\n          border-start-start-radius: unset;\n          border-start-end-radius: unset;\n          border-end-start-radius: ").concat(((ref54 = props.imageCards) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.style) === null || ref55 === void 0 ? void 0 : ref55.borderRadius) || "0px", ";\n          border-end-end-radius: unset;\n        }\n\n         .addBottomRightGlobalRadius{\n          border-start-start-radius: unset;\n          border-start-end-radius: unset;\n          border-end-start-radius: unset;\n          border-end-end-radius: ").concat(((ref56 = props.imageCards) === null || ref56 === void 0 ? void 0 : (ref57 = ref56.style) === null || ref57 === void 0 ? void 0 : ref57.borderRadius) || "0px", ";\n        }\n      }") : "", "\n    \n    ").concat(((ref58 = props.inputs) === null || ref58 === void 0 ? void 0 : ref58.isEnabled) ? "input:not(.removeGlobalOverride){\n            border-radius: ".concat(((ref59 = props.inputs) === null || ref59 === void 0 ? void 0 : (ref60 = ref59.style) === null || ref60 === void 0 ? void 0 : ref60.borderRadius) || "0px", ";\n        }") : "", "\n    \n  }\n");
});

// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/utils.tsx
var utils = __webpack_require__(44369);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalStyle/globalSettingConstant.tsx
var globalSettingConstant = __webpack_require__(88403);
// EXTERNAL MODULE: ./src/utils/checkIfHomePage.ts
var checkIfHomePage = __webpack_require__(83107);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/TextfieldBox/index.tsx
var TextfieldBox = __webpack_require__(81477);
;// CONCATENATED MODULE: ./src/assets/svgExports/WhatsAppIcon3.js

var WhatsAppIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_1_14)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20 40C8.956 40 0 31.044 0 20C0 8.956 8.956 0 20 0C31.044 0 40 8.956 40 20C40 31.044 31.044 40 20 40Z",
                        fill: "#25D366"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M29.356 10.688C26.876 8.204 23.572 6.836 20.056 6.832C12.812 6.832 6.91199 12.728 6.91199 19.976C6.91199 22.292 7.51599 24.556 8.66799 26.548L6.80399 33.36L13.772 31.532C15.692 32.58 17.852 33.132 20.052 33.132H20.056C27.3 33.132 33.196 27.236 33.2 19.988C33.204 16.476 31.84 13.172 29.356 10.688ZM20.06 30.912H20.056C18.096 30.912 16.172 30.384 14.496 29.388L14.096 29.152L9.95999 30.236L11.064 26.204L10.804 25.792C9.71199 24.052 9.13199 22.044 9.13199 19.976C9.13599 13.952 14.036 9.052 20.064 9.052C22.984 9.052 25.724 10.192 27.788 12.256C29.852 14.32 30.988 17.068 30.984 19.984C30.984 26.012 26.08 30.912 20.06 30.912ZM26.052 22.728C25.724 22.564 24.108 21.768 23.808 21.66C23.508 21.552 23.288 21.496 23.068 21.824C22.848 22.152 22.22 22.892 22.028 23.112C21.836 23.332 21.644 23.36 21.316 23.196C20.988 23.032 19.928 22.684 18.676 21.564C17.7 20.692 17.04 19.616 16.848 19.288C16.656 18.96 16.828 18.78 16.992 18.616C17.14 18.468 17.32 18.232 17.484 18.04C17.648 17.848 17.704 17.712 17.812 17.492C17.92 17.272 17.868 17.08 17.784 16.916C17.7 16.752 17.044 15.136 16.772 14.476C16.504 13.836 16.236 13.924 16.032 13.912C15.84 13.904 15.62 13.9 15.404 13.9C15.184 13.9 14.828 13.984 14.528 14.312C14.228 14.64 13.38 15.436 13.38 17.052C13.38 18.668 14.556 20.232 14.72 20.448C14.884 20.668 17.036 23.984 20.332 25.408C21.116 25.748 21.728 25.948 22.204 26.1C22.992 26.352 23.708 26.316 24.272 26.232C24.904 26.136 26.216 25.436 26.488 24.672C26.76 23.904 26.76 23.248 26.68 23.112C26.6 22.976 26.38 22.896 26.052 22.728Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "40",
                        height: "40",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/redux/actions/leadgen.js
var leadgen = __webpack_require__(171);
// EXTERNAL MODULE: ./src/utils/getWhatsAppRedirectionUrl.js
var getWhatsAppRedirectionUrl = __webpack_require__(30066);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(95537);
// EXTERNAL MODULE: ./src/utils/regex.js
var regex = __webpack_require__(36083);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/components/WhatsAppLeadGenerationModal/index.tsx












function WhatsAppLeadGenerationModal() {
    var handleContact = function handleContact(value) {
        if (isNaN(Number(value)) || (value === null || value === void 0 ? void 0 : value.length) > 10) {
            return;
        }
        setContact(value === null || value === void 0 ? void 0 : value.trim());
    };
    var closeModal = function closeModal() {
        dispatch((0,common/* setWhatsAppLeadModalState */.lT)({
            show: false
        }));
    };
    var handleLeadSubmission = function handleLeadSubmission() {
        if (!(0,regex/* isValidPhoneNumber */.yf)(contact)) {
            (0,Toast/* toastNotifyError */.Lu)("Please enter a valid phone number!");
            return;
        }
        var finalMessage = message === null || message === void 0 ? void 0 : message.trim();
        if (!(finalMessage === null || finalMessage === void 0 ? void 0 : finalMessage.trim())) {
            (0,Toast/* toastNotifyError */.Lu)("Please enter a message!");
            return;
        }
        if ((finalMessage === null || finalMessage === void 0 ? void 0 : finalMessage.length) < 10) {
            (0,Toast/* toastNotifyError */.Lu)("Message is too short!");
            return;
        }
        if ((finalMessage === null || finalMessage === void 0 ? void 0 : finalMessage.length) > 100) {
            finalMessage = finalMessage === null || finalMessage === void 0 ? void 0 : finalMessage.slice(0, 100);
        }
        var leadPayload = {
            store_id: storeId,
            phone_number: contact,
            enquiry: message
        };
        dispatch((0,leadgen/* pushWhatsAppLead */.TF)(leadPayload));
        var completeMessage = encodeURIComponent("".concat(message, ". ").concat(storeUrl));
        window.open((0,getWhatsAppRedirectionUrl/* getWhatAppRedirectionUrl */.gi)(completeMessage), "_blank");
        closeModal();
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return {
            showModal: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.whatsAppLeadModalState) === null || ref1 === void 0 ? void 0 : ref1.show,
            storeUrl: (ref2 = state.storeReducer.store) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.store_info) === null || ref3 === void 0 ? void 0 : ref3.store_url,
            storeId: (ref4 = state.storeReducer.store) === null || ref4 === void 0 ? void 0 : ref4.store_id,
            userPhone: (ref5 = state.userReducer) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.phone
        };
    }), showModal = ref.showModal, storeUrl = ref.storeUrl, storeId = ref.storeId, userPhone = ref.userPhone;
    var ref1 = (0,react.useState)(userPhone !== null && userPhone !== void 0 ? userPhone : ""), contact = ref1[0], setContact = ref1[1];
    var ref2 = (0,react.useState)("Hi, I'm at your online store and need some help"), message = ref2[0], setMessage = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
        show: showModal,
        onClose: closeModal,
        customClasses: "!tw-rounded-[16px_16px_0px_0px] md:!tw-rounded-[16px] !tw-w-full md:!tw-w-[400px] !tw-min-w-fit",
        headingClasses: "!tw-border-none !tw-p-0",
        customCloseIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: closeModal,
            className: "tw-absolute tw-right-[16px] tw-top-[12px] tw-flex tw-h-[32px] tw-w-[32px] tw-items-center tw-justify-center tw-rounded-full tw-bg-[#F7F7F7]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                fontSize: "small"
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex !tw-min-h-[480px] tw-flex-1 tw-flex-col tw-justify-between tw-gap-[32px] tw-px-[24px] tw-py-[28px] md:!tw-min-h-fit ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-[24px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[16px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppIcon, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-[20px]/[100%] tw-font-semibold",
                                    children: "Chat with us on WhatsApp"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[20px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextfieldBox/* default */.Z, {
                                    placeholder: "Enter your number",
                                    value: contact,
                                    handleChange: handleContact,
                                    parentClass: "",
                                    borderRadiusClass: "!tw-rounded-[6px]",
                                    showErrorBox: false,
                                    rows: 1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextfieldBox/* default */.Z, {
                                    placeholder: "Enter your message or enquiry",
                                    value: message,
                                    handleChange: function(value) {
                                        return setMessage(value);
                                    },
                                    parentClass: "",
                                    borderRadiusClass: "!tw-rounded-[6px]",
                                    showErrorBox: false,
                                    rows: 4
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "primary",
                    className: "!tw-rounded-lg !tw-py-[12px] !tw-text-sm !tw-font-semibold",
                    onClick: handleLeadSubmission,
                    children: "Start a chat"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/index.tsx
/**
 * Common Layout
 */ 





























var B2bRfqFormModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7856), __webpack_require__.e(9228), __webpack_require__.e(2878), __webpack_require__.e(9748), __webpack_require__.e(2945)]).then(__webpack_require__.bind(__webpack_require__, 29748)).then(function(mod) {
        return mod.B2bRfqFormModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29748)
            ];
        }
    }
});
var RedirectionToWebConsoleModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(4070)]).then(__webpack_require__.bind(__webpack_require__, 44070));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44070)
            ];
        }
    }
});
var InaccessibleLayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4273).then(__webpack_require__.bind(__webpack_require__, 54273));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54273)
            ];
        }
    }
});
var ExitGatingModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 729).then(__webpack_require__.bind(__webpack_require__, 80729));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80729)
            ];
        }
    }
});
var IS_SERVER = "object" === "undefined";
var Layout = function(_param) {
    var store = _param.store, _title = _param.title, title = _title === void 0 ? "" : _title, _Icon = _param.Icon, Icon = _Icon === void 0 ? "" : _Icon, _favIcon = _param.favIcon, favIcon = _favIcon === void 0 ? "" : _favIcon, _metaDescription = _param.metaDescription, metaDescription = _metaDescription === void 0 ? "" : _metaDescription, _OGTitle = _param.OGTitle, OGTitle = _OGTitle === void 0 ? "" : _OGTitle, _OGDescription = _param.OGDescription, OGDescription = _OGDescription === void 0 ? "" : _OGDescription, _OGImage = _param.OGImage, OGImage = _OGImage === void 0 ? "" : _OGImage, children = _param.children, _keywords = _param.keywords, keywords = _keywords === void 0 ? "" : _keywords, _canonicalTagUrl = _param.canonicalTagUrl, canonicalTagUrl = _canonicalTagUrl === void 0 ? "" : _canonicalTagUrl, props = (0,_object_without_properties/* default */.Z)(_param, [
        "store",
        "title",
        "Icon",
        "favIcon",
        "metaDescription",
        "OGTitle",
        "OGDescription",
        "OGImage",
        "children",
        "keywords",
        "canonicalTagUrl"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isRedirectedToHome = (0,react.useRef)(false);
    var ref24 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalSettings = ref24.widgetContextState.globalSettings, _widgetContextActions = ref24.widgetContextActions, setGlobalSetting = _widgetContextActions.setGlobalSetting, setGlobalStyle = _widgetContextActions.setGlobalStyle;
    var ref25 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            globalStyleSSR: state.jsonWidgetsReducer.globalStyle || {},
            shouldLoadFeatureLocks: !state.commonReducer.featureLocksData.isFeatureLocksLoaded
        };
    }), storeData = ref25.storeData, shouldLoadFeatureLocks = ref25.shouldLoadFeatureLocks, globalStyleSSR = ref25.globalStyleSSR;
    var ref26 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            userData: state.userReducer,
            toggleMobileView: state.commonReducer.toggleMobileView,
            isLoginByEmail: !!((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.email),
            globalStyle: state.jsonWidgetsReducer.globalStyle || {}
        };
    }), userData = ref26.userData, toggleMobileView = ref26.toggleMobileView, isLoginByEmail = ref26.isLoginByEmail, globalStyle = ref26.globalStyle;
    var ref27 = (0,react.useState)({
        showInaccessibleView: false,
        showRedirectionModal: false
    }), showState = ref27[0], setShowState = ref27[1];
    var ref28 = getGLobalStyleEssentials(globalStyle), fontURls = ref28.fontURls, fontStyles = ref28.fontStyles;
    var _buttons = globalStyle.buttons, buttons = _buttons === void 0 ? {} : _buttons, _imageCards = globalStyle.imageCards, imageCards = _imageCards === void 0 ? {} : _imageCards, _inputs = globalStyle.inputs, inputs = _inputs === void 0 ? {} : _inputs;
    var storeInfo = store || storeData;
    var storeId = (props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : ref.store_id) || (storeData === null || storeData === void 0 ? void 0 : storeData.store_id);
    var memberOnlyLoginFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().memberOnlyLoginFeatureStatus;
    var ref29 = (0,useFeatureLocks/* useFeatureLocks */.r)(), fbPixelFeatureStatus = ref29.fbPixelFeatureStatus, googleTagFeatureStatus = ref29.googleTagFeatureStatus, googleAnalyticsFeatureStatus = ref29.googleAnalyticsFeatureStatus;
    var isMolUnlocked = (memberOnlyLoginFeatureStatus === null || memberOnlyLoginFeatureStatus === void 0 ? void 0 : memberOnlyLoginFeatureStatus.isLocked) === false;
    var isBrandWebsiteDemo = router.pathname.includes("/brand-website-theme-demo");
    var isAboutPage = router.pathname.includes("".concat(routes.PATH.DOMAIN_HOME).concat(routes.PATH.ABOUT_US));
    var isHomePage = (0,checkIfHomePage/* checkIfHomePage */.I)();
    (0,react.useLayoutEffect)(function() {
        var bodyElement = document.getElementsByTagName("body")[0];
        if (!(props === null || props === void 0 ? void 0 : props.isBuilder) && (fontURls === null || fontURls === void 0 ? void 0 : fontURls.length) && bodyElement) {
            bodyElement.style.fontFamily = fontURls[0].fontFamily;
        }
    }, [
        fontURls
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((0,checkIfThemeEditorOrPreview/* default */.Z)() && !isBrandWebsiteDemo) {
            var bodyElement = document.getElementsByTagName("body")[0];
            if (bodyElement) {
                bodyElement.style = "pointer-events: none";
            }
        }
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_type_flag) === constants/* B2B_STORE_TYPE_CONSTANT */.CB && (userData === null || userData === void 0 ? void 0 : userData.isLogin)) {
            dispatch((0,actions_storeInfo/* getB2bRfqInputFields */.f2)(undefined, storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id));
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var shouldRedirectToMOL = !(0,checkIfThemeEditorOrPreview/* default */.Z)() && isMolUnlocked && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.members_only_access) && !LocalStorageHelper/* default.get */.Z.get("isMemberAllowed&store_id=".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id)) && !router.pathname.includes(routes.PATH.MEMBER_LOGIN) && !router.pathname.includes(routes.PATH.BUILDER_PREVIEW);
        if (shouldRedirectToMOL && !props.isBuilder) {
            var ref1;
            var memberLoginRoute = (0,routes.getRoute)(routes.PATH.MEMBER_LOGIN, storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
            router.replace(memberLoginRoute);
        }
    }, [
        isMolUnlocked
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var globalStyleData = (0,lodash.cloneDeep)(globalStyleSSR);
        if (globalStyleData && ((ref = Object.keys(globalStyleData || {})) === null || ref === void 0 ? void 0 : ref.length)) {
            var globalStyleDataClone = {};
            for(var key in globalStyleData){
                if (globalConfigs/* GLOBAL_STYLE */.$[key] && globalStyleData[key]) globalStyleDataClone[key] = (0,lodash.merge)(globalConfigs/* GLOBAL_STYLE */.$[key], globalStyleData[key]);
            }
            setGlobalStyle(globalStyleDataClone);
            var updatedGlobalSetting = (0,utils.getUpdatedGlobalSetting)(globalStyleDataClone, globalSettings);
            setGlobalSetting(updatedGlobalSetting);
        }
    }, [
        globalStyleSSR
    ]);
    /**
   * Instead of putting this sequence of code in every container,
   * we can put it here and reduce the number of lines of code.
   * If there are any special ones, the can be put in respective
   * containers.
   *
   * These four are common and used thorughout the pages and containers
   */ (0,react.useEffect)(function() {
        /* Save store info */ if (Object.keys((props === null || props === void 0 ? void 0 : props.storeInfo) || {}).length) {
            dispatch((0,actions_storeInfo/* saveStoreInfo */.nx)((props === null || props === void 0 ? void 0 : props.storeInfo) || {}));
        }
    }, [
        props === null || props === void 0 ? void 0 : props.storeInfo
    ]);
    (0,react.useEffect)(function() {
        if (storeId) {
            dispatch((0,catalog/* getCustomerReviewSettings */.vV)(storeId));
        }
    }, [
        storeId
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var storeInfo = store || storeData;
        var route = (0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        if (!isRedirectedToHome.current && storeInfo.store_id && storeInfo.domain_info.status === 2 && !route.includes(location.pathname)) {
            isRedirectedToHome.current = true;
            router.replace(route);
        }
    }, [
        storeData
    ]);
    (0,react.useEffect)(function() {
        if (storeId && shouldLoadFeatureLocks) dispatch((0,common/* fetchFeatureLocks */.Fc)(storeId));
    }, [
        storeId,
        shouldLoadFeatureLocks
    ]);
    var loginBtnClick = function() {
        setShowState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showRedirectionModal: true
            });
        });
    };
    var showIframeView = function() {
        dispatch((0,common/* toggleInaccessibleView */.g7)(true));
        setShowState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                showInaccessibleView: false
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !(props === null || props === void 0 ? void 0 : props.isBuilder) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyleWrapper, {
                fontStyles: fontStyles,
                buttons: buttons,
                imageCards: imageCards,
                inputs: inputs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dd-showrom__layout",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            ((fontURls === null || fontURls === void 0 ? void 0 : fontURls.length) || (props === null || props === void 0 ? void 0 : props.isBuilder)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "preconnect",
                                        href: "https://fonts.googleapis.com"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "preconnect",
                                        href: "https://fonts.gstatic.com",
                                        crossOrigin: "anonymous"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "viewport",
                                content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: metaDescription
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "keywords",
                                content: keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: OGTitle || title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: OGDescription || metaDescription
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: OGImage || Icon || constants_images/* DEFAULT_SSR_IMAGE_URL */.a
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:width",
                                content: "300"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:height",
                                content: "300"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: OGTitle || title,
                                id: "twittertitle"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: OGDescription || metaDescription,
                                id: "twitterdescription"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: OGImage || Icon || constants_images/* DEFAULT_SSR_IMAGE_URL */.a,
                                id: "twitterimage"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary"
                            }),
                            (store === null || store === void 0 ? void 0 : (ref1 = store.store_marketing_tags) === null || ref1 === void 0 ? void 0 : ref1.gmc_verification) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "google-site-verification",
                                content: store === null || store === void 0 ? void 0 : (ref2 = store.store_marketing_tags) === null || ref2 === void 0 ? void 0 : ref2.gmc_verification
                            }),
                            (store === null || store === void 0 ? void 0 : (ref3 = store.store_marketing_tags) === null || ref3 === void 0 ? void 0 : ref3.fb_domain_verification) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "facebook-domain-verification",
                                content: store === null || store === void 0 ? void 0 : (ref4 = store.store_marketing_tags) === null || ref4 === void 0 ? void 0 : ref4.fb_domain_verification
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: canonicalTagUrl || "".concat(store === null || store === void 0 ? void 0 : (ref5 = store.store_info) === null || ref5 === void 0 ? void 0 : ref5.store_url).concat((0,routes.getDefaultCanonicalUrl)(router === null || router === void 0 ? void 0 : router.asPath))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "shortcut icon",
                                type: "image/png",
                                href: (storeData === null || storeData === void 0 ? void 0 : storeData.favicon) || constants_images/* DEFAULT_SSR_IMAGE_URL */.a
                            }),
                            !(props === null || props === void 0 ? void 0 : props.isBuilder) && (fontURls === null || fontURls === void 0 ? void 0 : fontURls.map(function(fontData) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                            as: "font",
                                            href: fontData.fontCdn,
                                            rel: "preload",
                                            crossOrigin: "anonymous"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                            href: fontData.fontCdn,
                                            rel: "stylesheet",
                                            crossOrigin: "anonymous"
                                        })
                                    ]
                                }, fontData.fontCdn);
                            })),
                            (props === null || props === void 0 ? void 0 : props.isBuilder) && (globalSettingConstant/* FONT_DROPDOWN */.W9 === null || globalSettingConstant/* FONT_DROPDOWN */.W9 === void 0 ? void 0 : globalSettingConstant/* FONT_DROPDOWN.map */.W9.map(function(fontData) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("link", {
                                    href: fontData === null || fontData === void 0 ? void 0 : fontData.fontCdn,
                                    rel: "stylesheet",
                                    crossOrigin: "anonymous"
                                }, fontData === null || fontData === void 0 ? void 0 : fontData.fontCdn);
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "manifest",
                                href: "/api/manifest?domain=".concat(encodeURIComponent(store === null || store === void 0 ? void 0 : (ref6 = store.store_info) === null || ref6 === void 0 ? void 0 : ref6.domain), "&banner=").concat(encodeURIComponent(store === null || store === void 0 ? void 0 : (ref7 = store.store_info) === null || ref7 === void 0 ? void 0 : ref7.name), "&logo=").concat(encodeURI(store === null || store === void 0 ? void 0 : (ref8 = store.store_info) === null || ref8 === void 0 ? void 0 : ref8.logo_image), "&url=").concat(encodeURI(store === null || store === void 0 ? void 0 : (ref9 = store.store_info) === null || ref9 === void 0 ? void 0 : ref9.store_url))
                            }),
                            (store === null || store === void 0 ? void 0 : (ref10 = store.store_marketing_tags) === null || ref10 === void 0 ? void 0 : ref10.facebook_pixel) && !(fbPixelFeatureStatus === null || fbPixelFeatureStatus === void 0 ? void 0 : fbPixelFeatureStatus.isLocked) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        dangerouslySetInnerHTML: {
                                            __html: "\n                  !function(f,b,e,v,n,t,s)\n                  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n                  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n                  n.queue=[];t=b.createElement(e);t.async=!0;\n                  t.src=v;s=b.getElementsByTagName(e)[0];\n                  s.parentNode.insertBefore(t,s)}(window, document,'script',\n                  'https://connect.facebook.net/en_US/fbevents.js');\n                  fbq('init', '".concat(store === null || store === void 0 ? void 0 : store.store_marketing_tags.facebook_pixel, "');\n                  fbq('track', 'PageView');\n                ")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            height: "1",
                                            width: "1",
                                            style: {
                                                display: "none"
                                            },
                                            src: "https://www.facebook.com/tr?id=".concat(store === null || store === void 0 ? void 0 : store.store_marketing_tags.facebook_pixel, "&ev=PageView&noscript=1")
                                        })
                                    })
                                ]
                            }),
                            (store === null || store === void 0 ? void 0 : (ref11 = store.store_marketing_tags) === null || ref11 === void 0 ? void 0 : ref11.google_analytics) && !(googleAnalyticsFeatureStatus === null || googleAnalyticsFeatureStatus === void 0 ? void 0 : googleAnalyticsFeatureStatus.isLocked) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        async: true,
                                        src: "https://www.googletagmanager.com/gtag/js?id=".concat(store === null || store === void 0 ? void 0 : store.store_marketing_tags.google_analytics)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        dangerouslySetInnerHTML: {
                                            __html: "\n                window.dataLayer = window.dataLayer || [];\n                function gtag(){dataLayer.push(arguments);}\n                gtag('js', new Date());\n\n                gtag('config', '".concat(store === null || store === void 0 ? void 0 : store.store_marketing_tags.google_analytics, "');\n                ")
                                        }
                                    })
                                ]
                            }),
                            (store === null || store === void 0 ? void 0 : (ref12 = store.store_marketing_tags) === null || ref12 === void 0 ? void 0 : ref12.google_ads) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        async: true,
                                        src: "https://www.googletagmanager.com/gtag/js?id=".concat(store.store_marketing_tags.google_ads)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        dangerouslySetInnerHTML: {
                                            __html: "\n                 window.dataLayer = window.dataLayer || [];\n                 function gtag(){dataLayer.push(arguments);}\n                 gtag('js', new Date());\n \n                 gtag('config', '".concat(store.store_marketing_tags.google_ads, "');\n               ")
                                        }
                                    })
                                ]
                            }),
                            (store === null || store === void 0 ? void 0 : (ref13 = store.store_marketing_tags) === null || ref13 === void 0 ? void 0 : ref13.g_tag) && !(googleTagFeatureStatus === null || googleTagFeatureStatus === void 0 ? void 0 : googleTagFeatureStatus.isLocked) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        async: true,
                                        src: "https://www.googletagmanager.com/gtag/js?id=".concat(store === null || store === void 0 ? void 0 : (ref14 = store.store_marketing_tags) === null || ref14 === void 0 ? void 0 : ref14.g_tag)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        dangerouslySetInnerHTML: {
                                            __html: "\n                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                })(window,document,'script','dataLayer','".concat(store === null || store === void 0 ? void 0 : (ref15 = store.store_marketing_tags) === null || ref15 === void 0 ? void 0 : ref15.g_tag, "');\n                ")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        dangerouslySetInnerHTML: {
                                            __html: "\n                window.dataLayer = window.dataLayer || [];\n                function gtag(){dataLayer.push(arguments);}\n                gtag('js', new Date());\n\n                gtag('config', '".concat(store === null || store === void 0 ? void 0 : (ref16 = store.store_marketing_tags) === null || ref16 === void 0 ? void 0 : ref16.g_tag, "');")
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        async: true,
                                        src: "https://www.googletagmanager.com/gtag/js?id=G-LLCH0NYZ61"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                        dangerouslySetInnerHTML: {
                                            __html: "\n                window.dataLayer = window.dataLayer || [];\n                function gtag(){dataLayer.push(arguments);}\n                gtag('js', new Date());\n\n                gtag('config', 'G-LLCH0NYZ61');"
                                        }
                                    })
                                ]
                            }),
                            (store === null || store === void 0 ? void 0 : (ref17 = store.domain_info) === null || ref17 === void 0 ? void 0 : ref17.site_id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                dangerouslySetInnerHTML: {
                                    __html: "\n              var _paq = window._paq = window._paq || [];\n              /* tracker methods like \"setCustomDimension\" should be called before \"trackPageView\" */\n              _paq.push(['trackPageView']);\n              _paq.push(['enableLinkTracking']);\n              (function() {\n                var u=\"//matomo.dotshowroom.in/\";\n                _paq.push(['setTrackerUrl', u+'matomo.php']);\n                _paq.push(['setSiteId', ".concat(store === null || store === void 0 ? void 0 : (ref18 = store.domain_info) === null || ref18 === void 0 ? void 0 : ref18.site_id, "]);\n                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n                g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);\n              })();\n            ")
                                }
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeCss, {}),
                    (isHomePage || isAboutPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichSnippetStoreDetails, {
                        store: store
                    }),
                    (store === null || store === void 0 ? void 0 : (ref19 = store.store_marketing_tags) === null || ref19 === void 0 ? void 0 : ref19.g_tag) && /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: "//www.googletagmanager.com/ns.html?id=".concat(store === null || store === void 0 ? void 0 : (ref20 = store.store_marketing_tags) === null || ref20 === void 0 ? void 0 : ref20.g_tag),
                            height: "0",
                            width: "0",
                            title: "Google Tag Manager",
                            style: {
                                display: "none",
                                visibility: "hidden"
                            }
                        })
                    }),
                    (store === null || store === void 0 ? void 0 : (ref21 = store.domain_info) === null || ref21 === void 0 ? void 0 : ref21.status) !== 2 && toggleMobileView ? !IS_SERVER && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mobile-screen relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inaccessibleLayer-login flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "If you are the owner of this website then"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "login & enable desktop theme"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "login-btn pointer relative dib ml3",
                                        onClick: loginBtnClick,
                                        children: "Log In"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: window.location.href,
                                    height: "100%",
                                    width: "100%"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: children
                    }),
                    !!showState.showInaccessibleView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InaccessibleLayer, {
                        store: store,
                        show: showState.showInaccessibleView,
                        redirectToBadShowcase: showIframeView
                    }) : null,
                    !!showState.showRedirectionModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RedirectionToWebConsoleModal, {
                        show: showState.showRedirectionModal
                    }) : null,
                    (storeData === null || storeData === void 0 ? void 0 : (ref22 = storeData.services) === null || ref22 === void 0 ? void 0 : ref22.store_type_flag) === constants/* B2B_STORE_TYPE_CONSTANT */.CB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(B2bRfqFormModal, {
                        productData: (props === null || props === void 0 ? void 0 : props.product) || {}
                    }) : null,
                    (storeData === null || storeData === void 0 ? void 0 : (ref23 = storeData.services) === null || ref23 === void 0 ? void 0 : ref23.exit_gating_flag) && !isLoginByEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitGatingModal, {}) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_PromoModal, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_PromoRemovalAlertModal, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsAppLeadGenerationModal, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 35069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5492);



var checkIfThemeEditorOrPreview = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6 && (window.location.href.includes("showroom-preview") || !!(0,_getUrlParams__WEBPACK_IMPORTED_MODULE_2__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .PREVIEW_PARAMS.THEME_PAGE */ .I.THEME_PAGE
    ])[_constants__WEBPACK_IMPORTED_MODULE_1__/* .PREVIEW_PARAMS.THEME_PAGE */ .I.THEME_PAGE]);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfThemeEditorOrPreview);


/***/ }),

/***/ 84320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ DEFAULT_SSR_IMAGE_URL; }
/* harmony export */ });
var DEFAULT_SSR_IMAGE_URL = "https://cdn.dotpe.in/kiranaStatic/image/default-ssr-icon-22092020.png";


/***/ })

}]);